// @ts-nocheck
export const getFormattedDate = (date: string | Date): string => {
  return new Date(date).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const getLocalDate = (date: string | Date): Date => {
  const formatDate = typeof date === 'string' ? new Date(date) : date;
  return new Date(formatDate.getTime() - formatDate.getTimezoneOffset() * 60000);
};

export const isDateInPast = (date: string): boolean => {
  const now = new Date();
  const dueDate = new Date(date);
  return dueDate < now;
};

export const isOneDayBeforeDeadline = (deadline: string): boolean => {
  const dueDate = new Date(deadline);
  const now = new Date();
  dueDate.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);
  const timeDifference = now.getTime() - dueDate.getTime();
  const dayDifference = timeDifference / (1000 * 60 * 60 * 24);
  return dayDifference === -1;
};

export const timeSince = (date: Date): string => {
  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

  const formatInterval = (value: number, unit: string): string => {
    return `${Math.floor(value)} ${unit}${Math.floor(value) === 1 ? ' ago' : 's ago'}`;
  };

  if (seconds >= 31536000) return formatInterval(seconds / 31536000, 'year');
  if (seconds >= 2592000) return formatInterval(seconds / 2592000, 'month');
  if (seconds >= 86400) return formatInterval(seconds / 86400, 'day');
  if (seconds >= 3600) return formatInterval(seconds / 3600, 'hour');
  if (seconds >= 60) return formatInterval(seconds / 60, 'minute');

  return 'just now';
};

export const getFormattedDateOnly = (date: string | Date): string => {
  return getLocalDate(date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  });
};
